import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// Legacy `/day?date=` deep links (bookmarks, .fit mismatch callouts) land on
// the ledger with that day selected.
const searchSchema = z.object({ date: z.string().optional() });

export const Route = createFileRoute('/day')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/log', search: search.date ? { date: search.date, row: 'day' } : {} });
  },
});
